import AppButton from '@/components/ui/app-button';
import { IconShoppingCart } from '@/components/ui/icons';
import { useCart } from '@/context/auth/cart-context';
import { useSelectedLayoutSegments } from 'next/navigation';

interface CartButtonProps {
    isScrolled?: boolean;
    className?: string;
    isMobile?: boolean;
}

export default function CartButton({ isScrolled, className, isMobile }: CartButtonProps) {
    const { cart } = useCart();

    const segments = useSelectedLayoutSegments();

    return (
        <AppButton
            href="/cart"
            customClassName={`relative ${className} ${segments[0] === 'cart' ? 'bg-white/30 hover:bg-white/30' : isScrolled ? `${!isMobile ? 'bg-white/10 hover:bg-white/25' : ''}` : `${!isMobile ? 'bg-white/10  hover:bg-white/15' : ''}`}`}
        >
            {cart?.programs && cart?.programs.length > 0 && (
                <div className="absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/2 leading-none font-medium text-[12px] rounded-[4px] bg-[#B10DCE] text-white p-[4px]">
                    {cart.programs.length}
                </div>
            )}
            <IconShoppingCart />
        </AppButton>
    );
}
